import { useState, useEffect } from "react";
import { useTenantConfig, useWaitlistConfig } from "../../../hooks/useTenantConfig";
import { useApiConfig } from "../../../hooks/useApiConfig";
import BaseSelectInput from "../BaseSelectInput";
import { T } from "react-translator-component";

export default function ProgramsSelectInputNew({ value, bold = true, handleChange, required = false }) {
  const { outletId } = useApiConfig();
  const { data: tenantConfig, isLoading, isError } = useTenantConfig(outletId);
  const waitlistConfig = useWaitlistConfig(tenantConfig);
  
  const [program, setProgram] = useState(T("Programs"));

  // Extract programs from waitlist config
  const programs = waitlistConfig?.programPrioritization 
    ? waitlistConfig.programPrioritization.map((programName) => ({
        value: programName,
        label: programName,
      }))
    : [];

  const handleSelectedProgram = (event) => {
    setProgram(event.target.value);
    handleChange(event);
  };

  useEffect(() => {
    setProgram(value);
  }, [value]);

  return (
    <BaseSelectInput
      options={programs}
      bold={bold}
      handleChange={handleSelectedProgram}
      name={"programID"}
      id={"program"}
      placeholder={T("Programs")}
      selectedValue={program}
      required={required}
    />
  );
}
